document.addEventListener('alpine:init', () => {
  Alpine.data("accordion", () => ({
    //TODO: Do we need to add labelledby prop to the container somehow?
    open: false,
    menuTitle: "",
    accordionTrigger: {
      ["x-ref"]: "trigger",
      ["@click"]() {
        this.open = !this.open;
      },
      // [":aria-controls"]() {
      //   return `accordion--${this.menuTitle}`;
      // },
      [":aria-expanded"]() {
        return this.open;
      },
    },
    accordionContent: {
      ["x-init"]() {
        this.$watch("open", (open) => {
          if (open) {
            window.slideDown(this.$el);
          } else {
            window.slideUp(this.$el);
          }
        });
      },
      [":class"]() {
        return "accordion-content";
      },
      [":aria-hidden"]() {
        return !this.open;
      },
      // [":id"]() {
      //   return `accordion--${this.menuTitle}`; //TODO: Needs real ID set
      // },
    },
  }));
});
